<label class="button checkbox-wrapper">
    <input type="checkbox" i18n-checked [checked]="checked" [disabled]="disabled" (change)="changed.emit()" />
    <span class="custom-checkbox"></span><ng-content></ng-content>
</label>
